











import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
@Component({
  name: 'loading'
})
export default class loading extends Vue {
  loadingOfIframe () {
    this.$emit('loadingOfIframe', 'isRehresh')
  }
}
